import { Edge } from "reactflow";

export enum EdgeType {
  DefaultEdge = "defaultEdge",
  SmartJumpEdge = "smartJumpEdge",
  TaskConnector = "taskConnector",
  TriggersConnector = "triggersConnector",
}

export type SourceHandle =
  | "SUCCESSFUL"
  | "FAILED"
  | "ELSE"
  | "APPROVED"
  | "DECLINED"
  | "NOT_REVIEWED"
  | "PASSED"
  | "TEMP"
  | "AUTOMATION";

export type EdgeData = {
  type: "connection" | "jump";
  isConnectingToTrigger?: boolean;
  isJumpEdge?: boolean;
};

export type FlowEdge = Edge<EdgeData>;
